import type { PathLookupEdgeData } from '@ipfabric/utils';
import type { GraphData } from 'components/Graph/model/GraphData';
import type { ShowPathLookupEdgeDetailCommand } from '../model/commands/showPathLookupEdgeDetail';

export const getShowPathLookupDetailArgs = (
  edgeData: PathLookupEdgeData,
  graphData: GraphData,
): ShowPathLookupEdgeDetailCommand => ({
  detail: {
    edgeDirection: edgeData.direction,
    id: edgeData.id,
    labels: edgeData.labels,
    showAnimation: true,
    sourceLabel: graphData.nodes[edgeData.source]?.label ?? null,
    targetLabel: graphData.nodes[edgeData.target]?.label ?? null,
    packet: edgeData.packet,
  },
});
